// Module
var code = "<div ng-view=\"\" id=\"ng-view\" ng-class=\"routeAnimationClasses()\" class=\"animated\" ng-show=\"!resolvingRouteTakingSomeTime\"></div><front-royal-spinner class=\"fixed\" ng-if=\"resolvingRouteTakingSomeTime || signingOut\"></front-royal-spinner>";
// Exports
export default code;